import { ref as a } from "vue";
const g = () => {
  const s = a("300ms");
  return {
    setExpandTransitionDuration: (t) => {
      s.value = t;
    },
    leave: (t) => {
      const i = getComputedStyle(t).height;
      t.style.height = i, getComputedStyle(t).height, requestAnimationFrame(() => {
        t.style.transitionTimingFunction = "cubic-bezier(.63, .01, 1, 1.01)", t.style.height = 0, t.style.opacity = 0;
      });
    },
    enter: (t) => {
      const i = getComputedStyle(t).width;
      t.style.width = i, t.style.position = "absolute", t.style.visibility = "hidden", t.style.height = "auto";
      const o = getComputedStyle(t).height;
      t.style.width = null, t.style.position = null, t.style.visibility = null, t.style.height = 0, t.style.opacity = 0, t.style.transition = `all ${s.value}`, getComputedStyle(t).height, requestAnimationFrame(() => {
        t.style.transitionTimingFunction = "cubic-bezier(.63, .01, 1, 1.01)", t.style.height = o, t.style.opacity = 1;
      });
    },
    afterEnter: (t) => {
      t.style.height = "auto";
    }
  };
};
export {
  g as useTransitionExpand
};
